import React,{useCallback,useEffect,useState}from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUsers, faClock, faPlay, faRobot, faBrain, faChartLine, faCode, faProjectDiagram, faCloud, faCheckCircle, faDatabase, faServer, faLaptopCode, faCertificate, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faTwitter, faMedium } from '@fortawesome/free-brands-svg-icons';
import './HeroSection.css';
 
const MobileDevelopment = () => {
   const [showModal, setShowModal] = useState(false);
        const [formCourseName, setFormCourseName] = useState('Mobile Development');
        const [formData, setFormData] = useState({
          fullName: '',
          mobileNumber: '',
          email: '',
        });
      
        const openModal = () => setShowModal(true);
        const closeModal = useCallback(() => {
          setShowModal(false);
          setFormData({ fullName: '', mobileNumber: '', email: '' });
        }, []);
      
        useEffect(() => {
          const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
          };
          window.addEventListener('keydown', handleEsc);
          return () => window.removeEventListener('keydown', handleEsc);
        }, [closeModal]);
      
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          if (name === 'mobileNumber') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
              setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
          } else {
            setFormData(prev => ({ ...prev, [name]: value }));
          }
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const { fullName, mobileNumber, email } = formData;
      
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
            alert('Please fill in valid details.');
            return;
          }
      
          try {
            const response = await fetch('https://api.dikshasea.in/api/enrollments', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...formData, course: formCourseName }),
            });
      
            const result = await response.json();
            if (response.ok) {
              alert('Enrollment successful!');
              closeModal();
            } else {
              alert(result.message || 'Submission failed');
            }
          } catch (err) {
            console.error(err);
            alert('Error submitting form');
          }
        };
      
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="hero-title">
                Master <span className="hero-highlight">Mobile Development</span>
              </h1>
              <p className="hero-subtitle">
                Become a proficient mobile developer with our comprehensive course covering iOS and Android platforms.
                Learn to build high-performance apps using modern frameworks and tools.
              </p>
             
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.8/5.0</div>
                    <small className="text-muted">(1,890 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">6,500+</div>
                    <small className="text-muted">Students</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">60 hours</div>
                    <small className="text-muted">Content</small>
                  </div>
                </div>
              </div>
             
              <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img
                  src="subcourses-images/mobile-developer.jpg"
                  alt="Mobile Development Course"
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
     <div className="container">
      <div className="course-details">
        <div className="course-content">
          {/* About Course */}
          <section className="about-course">
            <h2 className="section-title">About This Course</h2>
            <p>This comprehensive Mobile Development program will take you from beginner to job-ready mobile developer. You'll learn to build cross-platform and native mobile applications using industry-standard tools and frameworks.</p>
            <p>Through hands-on projects, you'll gain experience building real-world apps with the same technologies used by top companies like Google, Facebook, and Uber.</p>
          </section>
         
          {/* Curriculum */}
          <section className="curriculum">
            <h2 className="section-title">Curriculum</h2>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 1: Foundations of Mobile Development</h3>
              <p>Learn the core concepts and architecture patterns of mobile applications</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Mobile UI/UX principles</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Platform differences (iOS vs Android)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Mobile app architecture</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Performance optimization</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faLaptopCode} className="me-2" /> Module 2: Native Development</h3>
              <p>Master native app development for iOS and Android platforms</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Swift for iOS development</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Kotlin for Android development</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Platform-specific APIs</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> App store submission process</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 3: Cross-Platform Development</h3>
              <p>Build apps that work on multiple platforms using modern frameworks</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> React Native framework</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Flutter development</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Hybrid vs native performance</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Code sharing strategies</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCloud} className="me-2" /> Module 4: Backend Integration</h3>
              <p>Connect your mobile apps to cloud services and APIs</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> RESTful API consumption</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Firebase integration</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Authentication systems</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Offline-first strategies</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 5: Capstone Project</h3>
              <p>Build a complete mobile application from concept to deployment</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Project planning and design</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Implementation of core features</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Testing and debugging</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Deployment to app stores</div>
              </div>
            </div>
          </section>
         
        </div>  
       
        <div className="course-sidebar">
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div className="info-content">
              <h4>Duration</h4>
              <p>14 Weeks (15 hrs/week)</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <div className="info-content">
              <h4>Level</h4>
              <p>Beginner to Advanced</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <div className="info-content">
              <h4>Projects</h4>
              <p>6 Real-world Apps</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="info-content">
              <h4>Prerequisites</h4>
              <p>JavaScript, Basic Programming</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div className="info-content">
              <h4>Career Support</h4>
              <p>Portfolio reviews, App store optimization</p>
            </div>
          </div>
         
          <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
        </div>
      </div>
    </div>
    {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">Mobile Development</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
 
export default MobileDevelopment;